import { IUser } from 'types';
import { UserRoles } from 'constants/user';
import { PROFILE_COMPLETED_FIELDS } from 'constants/user-form';
import DefaultPicture from 'assets/images/user.webp';
import { hasRole } from './auth-context';
import { getAge } from 'helpers';

export const isFamilyOwner = ({ families, currentFamilyId }: IUser) => {
  const currentFamily =
    families && families.find(R.propEq('id', currentFamilyId));
  return currentFamily && currentFamily.familyOwner;
};

export const ruleContainsPolicyType = (rule, policyType) =>
  rule.policies.includes(policyType);

export const isProfileUpdated = (user) =>
  !!PROFILE_COMPLETED_FIELDS.find((f) => !!user[f]);

export const getSharedFamily = (families = []) =>
  families.find((f) => !f.familyOwner);

export const getFamily = (families = []) => families.find((f) => f.familyOwner);

export const isUserFirstTimeUploadAttachment = (user: IUser) =>
  !user.hasAttachment;

export const getAdviser = (advisers = [], id) =>
  advisers.find(R.propEq('id', id));

export const hasEmployer = ({ employerId, otherEmployerName }: IUser) =>
  employerId || otherEmployerName;
export const mapEmployerOptions = R.map(({ id, name, searchable }) => ({
  key: id,
  text: name,
  value: id,
  searchable, // You can include the "searchable" field in the mapped object if needed.
}));

export const findEmployerById = (employers, id) =>
  employers.find(R.propEq('id', id));

export const getAdviserOrgId = R.path(['adviserOrg', 'id']);

// Returns true when user logged in via email/password instead of SSO
export const isNormalLogin = (id: string = '') =>
  id.includes('auth0') || id.includes('email');

export const getProfilePictureSrc = (picture) => picture || DefaultPicture;

export const isOnboardingUser = (user: IUser) => {
  if (hasRole(UserRoles.ADMIN)) {
    return false;
  }

  return (
    !user.premium && !user.walkthroughCompleted && !user.walkthroughSkipped
  );
};

export const getCCref = (item, reference) => {
  return reference.find(
    (ref) =>
      ref.id === item.creditCardId && ref.sk === item.creditCardProviderId,
  );
};

export const showShouldLifeAd = (user: IUser) => {
  return (
    user?.dateOfBirth &&
    getAge(user?.dateOfBirth) >= 20 &&
    getAge(user?.dateOfBirth) <= 70 &&
    user?.gender
  );
};

export const isLifeMSFlow = ({ utmCampaign = '' }: IUser) =>
  utmCampaign.toLowerCase().includes('life');
